module.exports = __webpack_public_path__ + "img/category_365.d41cc79c.jpg";